<template>
  <div class="comContent">
    <searchForm
      v-model="searchData"
      @getList="getList(1)"
      :labelList="expanded ? searchLabelList : expandedList"
      :expanded="expanded"
      :isExpanded="isExpanded"
      :searchData="searchData"
      @reset="resetForm"
      :showExport="false"
      :isShowAddress="true"
    ></searchForm>

    <myTable
      :index="index"
      :selection="false"
      :page="page"
      :showpage="true"
      :operation="false"
      v-loading="loading"
      :table-data="tableData"
      :table-option.sync="tableOption"
      @page-change="getList"
      :expand="false"
    >
      <template slot="qualificationStatus" slot-scope="scope">
        <div style="margin: 0 0px">
          <span
            :style="{
              color: qualificationStatusText[scope.row.qualificationStatus],
            }"
            ><i
              :class="
                scope.row.qualificationStatus === 6
                  ? 'el-icon-success'
                  : 'el-icon-warning'
              "
            ></i>
            {{ scope.row.qualificationStatusName }}</span
          >
        </div>
      </template>
      <template slot="shopCode" slot-scope="scope">
        <el-tooltip :content="scope.row.id" placement="bottom">
          <div slot="content">
            <span @click="copyText(scope.row.id, $event)" class="copy-text-btn">
              {{ scope.row.id }} 复制</span
            >
          </div>
          <div>
            {{ scope.row.shopCode }}
          </div>
        </el-tooltip>
      </template>

      <template slot="useAmount" slot-scope="scope">
        <div style="margin: 0 0px">
          <span
            >￥
            {{
              scope.row.guarantee && scope.row.guarantee.useAmount
                ? parseFloat(scope.row.guarantee.useAmount).toFixed(2)
                : "0.00"
            }}
          </span>
        </div>
      </template>
      <template slot="lockAmount" slot-scope="scope">
        <div style="margin: 0 0px">
          <span
            >￥
            {{
              scope.row.guarantee && scope.row.guarantee.lockAmount
                ? parseFloat(scope.row.guarantee.lockAmount).toFixed(2)
                : "0.00"
            }}
          </span>
        </div>
      </template>
      <template slot="shopBusinessStatus" slot-scope="scope">
        <div style="margin: 0 0px">
          <span style="color: #67c23a" v-if="scope.row.shopBusinessStatus == 0"
            ><i class="el-icon-success"></i> 启用</span
          >
          <span style="color: #f56c6c" v-if="scope.row.shopBusinessStatus == 2"
            ><i class="el-icon-success"></i> 关店</span
          >
          <span style="color: #e6a23c" v-if="scope.row.shopBusinessStatus == 1"
            ><i class="el-icon-error"></i> 冻结</span
          >
        </div>
      </template>
      <template slot="status" slot-scope="scope">
        <div style="margin: 0 0px">
          <span style="color: #67c23a" v-if="scope.row.status == 2"
            ><i class="el-icon-success"></i> 通过</span
          >
          <span style="color: #67c23a" v-if="scope.row.status == 20"
            ><i class="el-icon-success"></i> 一审通过</span
          >
          <span style="color: #f56c6c" v-if="scope.row.status == 1"
            ><i class="el-icon-success"></i> 未通过</span
          >
          <span style="color: #e6a23c" v-if="scope.row.status == 0"
            ><i class="el-icon-error"></i> 待审核</span
          >
        </div>
      </template>
      <template slot="operation" slot-scope="scope">
        <div style="margin: 0 0px">
          <el-link
            type="primary"
            :underline="false"
            @click="checkShop(scope.row)"
            style="margin-right: 10px"
          >
            检查
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            @click="checkDetails(scope.row, 1)"
            style="margin-right: 10px"
          >
            详情
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            v-if="scope.row.shopBusinessStatus != 2"
            @click="updateStatus(scope.row, 2, '关店')"
            style="margin-right: 10px"
          >
            关店
          </el-link>

          <el-link
            type="primary"
            :underline="false"
            v-if="scope.row.shopBusinessStatus == 0"
            @click="updateStatus(scope.row, 1, '冻结')"
            style="margin-right: 10px"
          >
            冻结
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            v-if="scope.row.shopBusinessStatus == 1"
            @click="updateStatus(scope.row, 0, '解冻')"
            style="margin-right: 10px"
          >
            解冻
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            @click="lookShopDetail(scope.row)"
            style="margin-right: 10px"
          >
            运营详情
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            @click="baozhengjin(scope.row)"
            style="margin-right: 10px"
          >
            保证金管理
          </el-link>
        </div>
      </template>
    </myTable>
    <el-dialog
      title="检查商户"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <div class="left_topic">检查项</div>
        <p>*药品信息展示</p>
        <p>*药品销售</p>
        <p>*订单配送</p>
        <p>*售后处理</p>
        <p>*资质</p>
        <div class="left_topic">检查结果</div>
        <el-input
          v-model="textArea"
          style="margin-top: 10px; width: 100%; height: 120px"
          placeholder="请输入内容"
          type="textarea"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submit()" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import searchForm from "../component/searchForm.vue";
import myTable from "@/components/myTable";
import {
  queryShopManageList,
  getListByType,
  updateBusinessStatus,
  checkShop,
} from "@/api/businessManage";
import clip from "@/utils/clipboard";

export default {
  name: "businessManageShopIndex",
  components: { searchForm, myTable },
  props: {},
  data() {
    return {
      expanded: true, //是否展开
      isExpanded: true, //是否有展开按钮
      dialogVisible: false,
      selectRow: {},
      textArea: "",
      loading: false,
      operation: false,
      selection: true,
      index: false,
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      qualificationStatusText: {
        1: "#E6A23C", //待审核
        2: "#E6A23C", //初审通过
        3: "#F5222D", //驳回
        4: "#F5222D", //过期
        5: "#E6A23C", //临期
        6: "#67C23A", //正常
      },
      tableOption: [
        { label: "商户ID", prop: "shopCode", width: 120, slot: true },
        { label: "商户名称", prop: "shopName", width: 260 },
        { label: "商户类型", prop: "shopType", width: 140 },
        { label: "保证金余额", prop: "useAmount", width: 140, slot: true },
        { label: "保证金占用金额", prop: "lockAmount", width: 140, slot: true },
        // { label: "登录用户名", prop: "loginUserName", width: 200 },
        { label: "在售商品", prop: "goodsForSaleCount", width: 100 },
        { label: "商家下架商品", prop: "removedGoodsCount", width: 120 },
        { label: "上架待审核商品", prop: "reviewedGoodsCount", width: 140 },
        {
          label: "资质状态",
          prop: "qualificationStatus", //资质状态名称(0.正常 ， 1.过期， 2.临期)
          width: 120,
          slot: true,
        },
        {
          label: "启用状态",
          prop: "shopBusinessStatus", //启用状态名称(0.正常 ， 1.冻结 ， 2.关店)
          width: 120,
          slot: true,
        },
        {
          label: "商户状态",
          prop: "status", //商户状态名称(0.待审核，1.未通过，2.通过,20.一审通过)
          width: 120,
          slot: true,
        },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 120,
          // fixed: "right",
        },
      ],
      searchData: {
        name: "",
        shopTypeId: "",
        shopBusinessStatus: "",
        shopType: "",
        certifyStatus: "",
        keyWords: "",
        status: "2",
      },
      expandedList: [
        {
          name: "商户ID/商户名称",
          fieldName: "keyWords",
          type: "input",
          width: "300px",
          placeholder: "商户ID/商户名称",
        },
      ],
      searchLabelList: [
        {
          name: "商户类型",
          fieldName: "shopTypeId",
          width: 150,
          type: "select",
          disabled: false,
          select: [],
        },
        {
          name: "启用状态",
          width: 150,
          fieldName: "shopBusinessStatus",
          type: "select",
          disabled: false,
          select: [
            {
              name: "启用",
              id: 0,
            },
            {
              name: "冻结",
              id: 1,
            },
            {
              name: "关店",
              id: 2,
            },
          ],
        },
        {
          name: "资质状态",
          width: 150,
          fieldName: "certifyStatus",
          type: "select",
          disabled: false,
          select: [
            {
              name: "过期",
              id: 2,
            },
            {
              name: "临期",
              id: 3,
            },
            {
              name: "正常",
              id: 1,
            },
          ],
        },
        {
          name: "商户状态",
          width: 150,
          fieldName: "status",
          type: "select",
          disabled: false,
          select: [
            {
              name: "待审核",
              id: "0",
            },
            {
              name: "未通过",
              id: "1",
            },
            {
              name: "通过",
              id: "2",
            },
            {
              name: "一审通过",
              id: "20",
            },
          ],
        },
        {
          name: "商户ID",
          fieldName: "shopCode",
          type: "input",
          disabled: false,
        },
        {
          name: "商户名称",
          fieldName: "shopName",
          type: "input",
        },
        // {
        //   name: "登录用户名",
        //   fieldName: "userName",
        //   type: "input",
        // }, //后端和产品确认去掉
      ],
      isRecord: false, //离开页面是否记录当前输入框的值
      recoderKey: "businessManage-shop-index",
    };
  },
  filters: {},
  async created() {
    // 首页「商户中心」跳转过来时以路由参数为准，否则恢复上次输入记录
    if (!this.applyRouteQuery()) {
      await this.getInputRecoderValue();
    }
    this.getListByType();
    this.getList();
  },
  beforeDestroy() {
    if (!this.isRecord) {
      this.$store.dispatch("pageRecorder/clearPageRecord");
    }
  },
  methods: {
    // 首页跳转参数回显：tab-资质状态(2.过期 3.临期) status-商户状态(0.待审核 2.通过 20.一审通过)
    applyRouteQuery() {
      const { tab, status } = this.$route.query;
      if (tab === undefined && status === undefined) {
        return false;
      }
      this.searchData = {
        name: "",
        shopTypeId: "",
        shopBusinessStatus: "",
        shopType: "",
        keyWords: "",
        // 资质状态选项 id 为数字，商户状态选项 id 为字符串，需保持类型一致才能选中
        certifyStatus: tab === undefined ? "" : Number(tab),
        status: status === undefined ? "" : String(status),
      };
      this.expanded = true; //展开筛选区，便于查看选中的状态
      return true;
    },
    // 记录输入框的值
    recordInput() {
      this.isRecord = true;
      this.$store.dispatch("pageRecorder/addPageRecord", {
        name: this.recoderKey,
        value: { ...this.searchData, expanded: this.expanded },
      });
    },
    // 获取页面记录
    getInputRecoderValue() {
      return new Promise((resolve) => {
        this.$store
          .dispatch("pageRecorder/getRecoderByName", this.recoderKey)
          .then((res) => {
            if (res) {
              this.searchData = res;
              this.expanded = res.expanded || false;
            }
          })
          .finally(() => {
            resolve();
          });
      });
    },
    copyText(str, event) {
      clip(str, event);
    },
    // 检查
    checkShop(row) {
      this.recordInput();
      this.$router.push({
        path: "./businessManage-checkShop-index",
        query: {
          shopId: row.id,
        },
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.textArea = "";
    },
    // 提交检查
    submit() {
      let params = {
        shopCode: this.selectRow.shopCode,
        shopId: this.selectRow.id,
        shopName: this.selectRow.shopName,
        shopTypeCode: this.selectRow.shopTypeCode,
        checkResult: this.textArea,
      };
      checkShop(params).then((res) => {
        if (res) {
          this.$message.success("提交成功");
          this.dialogVisible = false;
          this.textArea = "";
        } else {
          this.$message.error("提交失败");
        }
      });
    },
    lookShopDetail(row) {
      // 查看运营详情
      this.recordInput();
      this.$router.push(
        "./businessManage-shop-shopLookByAdmin?shopId=" + row.id
      );
    },
    baozhengjin(row) {
      this.recordInput();
      this.$router.push({
        path: "/business/businessManage-shop-deposit",
        query: {
          shopId: row.id,
          shopName: row.shopName,
        },
      });
    },
    updateStatus(row, status, typeText) {
      let params = {
        shopId: row.id,
        shopBusinessStatus: status,
      };
      if (status == 1 || status == 2) {
        this.$confirm(`确定要${typeText}【 ${row.shopName}】吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.updateBusinessStatus(params);
          })
          .catch(() => {});
      } else {
        this.updateBusinessStatus(params);
      }
      // 更新状态 商户业务状态(0：正常；1：冻结；2：注销)
    },

    updateBusinessStatus(params) {
      updateBusinessStatus(params).then((res) => {
        if (res.code == 0) {
          this.$message.success("提交成功");
          this.getList(1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 获取客户类型列表
    getListByType() {
      getListByType({
        type: 1, //商户类型
      }).then((res) => {
        console.log(res);
        let selectList = [];
        for (let i = 0; i < res.data.length; i++) {
          selectList.push({
            id: res.data[i].typeCode,
            name: res.data[i].typeName,
          });
        }
        console.log(selectList, "selectList---selectList");
        for (let i = 0; i < this.searchLabelList.length; i++) {
          if (this.searchLabelList[i].fieldName == "shopTypeId") {
            this.searchLabelList[i].select = selectList;
          }
        }
      });
    },
    getList(current) {
      if (this.searchData.date) {
        this.searchData.startTime = this.searchData.date[0];
        this.searchData.endTime = this.searchData.date[1];
      }
      // console.log(this.searchData)
      const params = Object.assign({}, this.searchData);
      params.size = this.page.size;
      console.log(params);
      if (params.date) {
        delete params.date;
      }
      if (current) {
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      queryShopManageList(params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    resetForm() {
      // this.searchData = {};
      this.page.current = 1;
      for (const key in this.searchData) {
        this.searchData[key] = "";
      }
      this.getList();
    },
    // 查看详情
    checkDetails(row) {
      this.recordInput();
      window.sessionStorage.setItem("shop-detail", JSON.stringify(row));
      this.$router.push("./businessManage-shop-detail?id=" + row.id);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-textarea {
  .el-textarea__inner {
    height: 100%;
  }
}

::v-deep.el-table {
  height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 88px) !important;
  overflow: auto !important;
}

.copy-text-btn {
  cursor: pointer;
}
</style>
